import React, { useState } from 'react';
import { auth as authApi } from '../services/api';

export const ResetPasswordPage = ({ token, onDone }) => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async () => {
    if (!password || !confirmPassword) {
      setError('Enter and confirm your new password');
      return;
    }
    if (password.length < 8) {
      setError('Password must be at least 8 characters');
      return;
    }
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    setLoading(true);
    setError('');
    try {
      const res = await authApi.resetPassword(token, password);
      setSuccess(res.message || 'Password updated successfully');
    } catch (err) {
      setError(err.message || 'Could not reset password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-screen">
      <div className="login-card">
        <div className="login-logo">
          <img src="/logo.webp" alt="huhslCap" />
        </div>

        <div className="login-title">Set a new password</div>
        <div className="login-desc">Choose a new password for your account.</div>

        {error && (
          <div style={{ background:'var(--danger-bg)', border:'1px solid var(--danger-border)', color:'var(--danger)', padding:'8px 12px', borderRadius:7, fontSize:12, marginBottom:14, textAlign:'center' }}>
            {error}
          </div>
        )}

        {success ? (
          <>
            <div style={{ background:'var(--success-bg)', border:'1px solid var(--success)', color:'var(--success)', padding:'10px 12px', borderRadius:7, fontSize:12, marginBottom:14, textAlign:'center' }}>
              {success}
            </div>
            <button className="btn-login" onClick={onDone}>
              Back to sign in
            </button>
          </>
        ) : (
          <>
            <div className="login-field">
              <label className="login-label">New password</label>
              <input
                className="login-input"
                type="password"
                value={password}
                autoComplete="new-password"
                placeholder="Min. 8 characters"
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
              />
            </div>
            <div className="login-field">
              <label className="login-label">Confirm password</label>
              <input
                className="login-input"
                type="password"
                value={confirmPassword}
                autoComplete="new-password"
                placeholder="Repeat new password"
                onChange={(e) => setConfirmPassword(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && handleSubmit()}
              />
            </div>

            <button className="btn-login" onClick={handleSubmit} disabled={loading} style={{ opacity: loading ? 0.7 : 1 }}>
              {loading ? 'Updating…' : 'Update password'}
            </button>
            <button type="button" className="login-link-btn" onClick={onDone} style={{ marginTop: 12 }}>
              Back to sign in
            </button>
          </>
        )}
      </div>
    </div>
  );
};
